///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const LogoutIcon = ({
  height,
  fill,
  title = messages.logout.defaultMessage,
  width,
  ...props
}) => (
  <svg
    aria-labelledby="logout-icon"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title id="logout-icon">{title}</title>
    <path
      d="M11.3333 5.33333L10.3933 6.27333L11.4467 7.33333H6V8.66667H11.4467L10.3933 9.72L11.3333 10.6667L14 8L11.3333 5.33333ZM3.33333 3.33333H8V2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H8V12.6667H3.33333V3.33333Z"
      fill="white"
    />
  </svg>
);

export default LogoutIcon;
